import { PRODUCT } from '@nolens/domain';

/** O símbolo Nolens (N com quatro nós, o último em teal) na cor do produto. */
export function Symbol({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="0.5" y="0.5" width="23" height="23" rx="6.5" fill={PRODUCT.tile} />
      <path
        d="M7 17V7l10 10V7"
        stroke="#F7F7F5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {[
        [7, 7],
        [7, 17],
        [17, 7],
      ].map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="1.6" fill="#F7F7F5" />
      ))}
      <circle cx="17" cy="17" r="1.9" fill={PRODUCT.bright} stroke="#F7F7F5" strokeWidth="0.8" />
    </svg>
  );
}

/** Nolens + descritor "Guides" na cor do produto. */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-2" aria-label={PRODUCT.fullName}>
      <Symbol size={size} />
      <span className="text-[15px] font-semibold tracking-tight text-text-1">
        Nolens <span className="font-medium text-[var(--brand-product)]">{PRODUCT.name}</span>
      </span>
    </span>
  );
}
